import { render, staticRenderFns } from "./FormularioMenuComponent.vue?vue&type=template&id=152806f4"
import script from "./FormularioMenuComponent.vue?vue&type=script&lang=js"
export * from "./FormularioMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports